export default __webpack_public_path__ + "static/media/vincennes10.aa766a32.jpg";